import { CONFIG } from 'app/core/config';
import { ViewModel } from '../view-model';
import { RunnableLookupRowsRangeDeleteDataRow } from './runnable-lookup-rows-range-delete-data-row';

export class RunnableLookupRowsRangeDeleteData implements ViewModel {
  friendlyTypeNameSingular: string = 'RunnableLookupRowsRangeDelete';
  apiRoute: string = CONFIG.apiRoutes.runnableLookupRowsRangeDelete;

  public rowsToDelete: RunnableLookupRowsRangeDeleteDataRow[] = [];
  public rowsToUpdate: RunnableLookupRowsRangeDeleteDataRow[] = [];
  public lookupId: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    if (data.rowsToDelete) {
      for (const row of data.rowsToDelete) {
        const newRow = new RunnableLookupRowsRangeDeleteDataRow();
        newRow.loadFromJson(row);
        this.rowsToDelete.push(newRow);
      }
    }
    if (data.rowsToUpdate) {
      for (const row of data.rowsToUpdate) {
        const newRow = new RunnableLookupRowsRangeDeleteDataRow();
        newRow.loadFromJson(row);
        this.rowsToUpdate.push(newRow);
      }
    }
  }
}
